export default "__VITE_ASSET__2c94a086__"